/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Cass from 'astro/server/entity/cass';

import makeStatus from 'astro/server/status/make';
import StatusProxy from 'astro/server/status/proxy';


export default class
{
  constructor (cass, planet)
  {
    this.planet = planet;

    this.cass = new Cass(cass);
    this.status = makeStatus(this.cass.getStatus(), this);
  }


  setup ()
  {
    this.statusProxy = this.makeStatusProxy();
  }


  makeStatusProxy ()
  {
    throw new Error('Not implemented');
  }


  install ()
  {
    this.status.install();
  }


  getCass ()
  {
    return this.cass;
  }


  getStatus ()
  {
    return this.status;
  }


  getStatusProxy ()
  {
    return this.statusProxy;
  }

  getPlanet ()
  {
    return this.planet;
  }


  getLocation (resolver)
  {
    return this.getZone().getLocation(resolver);
  }


  getZone ()
  {
    return this.planet.getZones().getOne(this.cass.getCoords());
  }


  getUser ()
  {
    return this.planet.getUsers().getUser(this.cass.getUser());
  }


  getConstants ()
  {
    return this.planet.getConstants().getEntity(this.cass.getVariant());
  }


  canFireProjectiles ()
  {
    return false;
  }


  // TODO not sure about this - we assume that only entity creates aggresive interactions
  // Would need to include increase_influence/resistance redirect_influence as aggressive!
  hasTarget ()
  {
    for (const interaction of this.planet.getInteractions().getInteractionsFrom(this.unit.source))
    {
      if (interaction.isAggressive())
      {
        return true;
      }
    }

    return false;
  }


}
